import { InspectionType, DamageSeverity } from "./enums";

const damageKey = damage =>
  `${damage.side}-${damage.row}-${damage.column}-${damage.severity}`;

function isDamagesEqual(damagesA, damagesB) {
  const keysA = new Set(damagesA.map(damageKey));
  const keysB = new Set(damagesB.map(damageKey));

  if (keysA.size !== keysB.size) return false;

  for (const key of keysA) {
    if (!keysB.has(key)) return false;
  }

  return true;
}

// BOLs completed before the inTransit flag shipped have no such property on
// their damages, so its absence means "fall back to comparing the damage sets"
const hasInTransitFlag = damages =>
  (damages ?? []).some(damage => damage.inTransit !== undefined);

export function areThereTransitDamages(
  inspectionType,
  dropoffDamages,
  pickupDamages,
) {
  if (inspectionType === InspectionType.Pickup) return true;

  // Keep this check being done first to ensure backwards compatibility with older BOLs that were completed with all "None" for dropoff rather than copying pickup damages
  const isDropoffAllNoneDamages = (dropoffDamages ?? []).every(
    damage => damage.severity === DamageSeverity.None,
  );

  if (isDropoffAllNoneDamages) return false;

  if (hasInTransitFlag(dropoffDamages)) {
    return (dropoffDamages ?? []).some(damage => damage.inTransit === true);
  }

  return !isDamagesEqual(pickupDamages ?? [], dropoffDamages ?? []);
}
